export const APP_URL = "https://app.pixro.ai";
export const API_URL = "https://admin-api.pixro.ai";
export const VITE_N8N_LEADS_CONTACT_FORM_WEBHOOK =
    "https://pixroai.app.n8n.cloud/webhook/landing-contact-form";
export const SITE_URL = "https://pixro.ai";
// Core backend (NestJS) — hosts the DukaanAds lead capture + Razorpay endpoints.
// export const CORE_API_URL = "https://api.pixro.ai";

// DukaanAds — placeholder brand + the WhatsApp number leads are sent to after payment.
export const DUKAAN_BRAND_NAME = "Dukaan Ads";
export const DUKAAN_WHATSAPP_NUMBER = "916364871993";
